module.exports = __webpack_public_path__ + "1a233cebf45a60f70b949e2df359ae58.svg";